<template>
    <el-dialog width="70%" :title="title" :visible="showDialog" @close="close" @open="getData">
        <div class="form-body">
            <div class="row">
                <div class="col-md-12" v-if="records.length > 0">
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>Fecha de gracia</th>
                                <th>Fecha de pago</th>
                                <th>Fecha real de pago</th>
                                <th>Método de pago</th>
                                <th>Tarjeta</th>
                                <th>Concepto</th>
                                <th>Monto</th>
                                <th>Estado</th>
                                <th>Acciones</th>
                                <th>Subir pago</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(row, index) in records">
                                <template v-if="row.id">
                                    <td>{{ row.date_of_due }}</td>
                                    <td>{{ row.date_of_payment }}</td>
                                    <td>{{ row.date_of_payment_real }}</td>
                                    <td>{{ row.payment_method_type_description }}</td>
                                    <td v-if="row.card_brand">{{ row.card_brand.description }}</td>
                                    <td v-else>-</td>
                                    <td>{{ row.reference }}</td>
                                    <td  >S/ {{ row.payment }}</td>
                                    <td>
                                        <el-tag :type="getTypeState(row.state)">
                                            {{ getNameState(row.state) }}
                                        </el-tag>
                                        
                                    </td>
                                    <td class="series-table-actions text-right">
                                        <button v-if="row.state === 'E'"
                                            type="button" class="btn waves-effect waves-light btn-xs btn-primary" @click.prevent="clickCancelPayment(row.id)">
                                            Pagar
                                        </button>
                                        <button v-if="!row.qty_notification && (row.state === 'E' || row.state === 'V')"
                                            type="button" class="btn waves-effect waves-light btn-xs btn-danger" @click.prevent="clickDelete(row.id)">Eliminar</button>
                                    </td>
                                    <td>
                                        <template v-if="row.file">
                                            <div class="d-flex align-items-center">
                                                <el-button type="success" plain
                                                    size="small"
                                                    round
                                                    @click="donwloadFile(row.id)"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 11.5V20m0 0l3-3m-3 3l-3-3M8 7.036a3.5 3.5 0 0 1 1.975.99M17.5 14c1.519 0 2.5-1.231 2.5-2.75a2.75 2.75 0 0 0-2.016-2.65A5 5 0 0 0 8.37 7.108a3.5 3.5 0 0 0-1.87 6.746"/></svg>
                                                </el-button>
                                                <el-button type="danger" plain
                                                    size="small"
                                                    round
                                                    @click="deleteFile(row.id)"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M10 2.25a.75.75 0 0 0-.75.75v.75H5a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5h-4.25V3a.75.75 0 0 0-.75-.75zm0 8.4a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-1.5 0v-7a.75.75 0 0 1 .75-.75m4.75.75a.75.75 0 0 0-1.5 0v7a.75.75 0 0 0 1.5 0z"/><path fill="currentColor" fill-rule="evenodd" d="M5.991 7.917a.75.75 0 0 1 .746-.667h10.526a.75.75 0 0 1 .746.667l.2 1.802c.363 3.265.363 6.56 0 9.826l-.02.177a2.85 2.85 0 0 1-2.44 2.51a27 27 0 0 1-7.498 0a2.85 2.85 0 0 1-2.44-2.51l-.02-.177a44.5 44.5 0 0 1 0-9.826zm1.417.833l-.126 1.134a43 43 0 0 0 0 9.495l.02.177a1.35 1.35 0 0 0 1.157 1.191c2.35.329 4.733.329 7.082 0a1.35 1.35 0 0 0 1.157-1.19l.02-.178c.35-3.155.35-6.34 0-9.495l-.126-1.134z" clip-rule="evenodd"/></svg>
                                                </el-button>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <el-upload
                                                class="upload-demo"
                                                :headers="headers"
                                                :action="`/${resource}/upload-direct`"
                                                :data="{'index': index, 'client_id': row.client_id, 'client_payment_id': row.id}"
                                                :multiple="false"
                                                :limit="1"
                                                :on-success="successUploadDirect"
                                                :show-file-list="false"
                                            >
                                                <el-button
                                                    slot="trigger" size="small"
                                                    type="primary"
                                                >
                                                    Seleccionar archivo
                                                </el-button>
                                                <div slot="tip" class="el-upload__tip" v-if="row.file">
                                                    Un archivo cargado
                                                </div>
                                            </el-upload>
                                        </template>
                                    </td>
                                </template>
                                <template v-else>
                                    <td>
                                        <div class="form-group mb-0" :class="{'has-danger': row.errors.date_of_due}">
                                            <el-date-picker v-model="row.date_of_due"
                                                            type="date"
                                                            :clearable="false"
                                                            format="dd/MM/yyyy"
                                                            value-format="yyyy-MM-dd"></el-date-picker>
                                            <small class="form-control-feedback" v-if="row.errors.date_of_due" v-text="row.errors.date_of_due[0]"></small>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group mb-0" :class="{'has-danger': row.errors.date_of_payment}">
                                            <el-date-picker v-model="row.date_of_payment"
                                                            type="date"
                                                            :clearable="false"
                                                            format="dd/MM/yyyy"
                                                            value-format="yyyy-MM-dd"></el-date-picker>
                                            <small class="form-control-feedback" v-if="row.errors.date_of_payment" v-text="row.errors.date_of_payment[0]"></small>
                                        </div>
                                    </td> 
                                    <td></td>
                                    <td>
                                        <div class="form-group mb-0" :class="{'has-danger': row.errors.payment_method_type_id}">
                                            <el-select v-model="row.payment_method_type_id" @change="changePaymentMethodType(row)">
                                                <el-option v-for="option in payment_method_types" :key="option.id" :value="option.id" :label="option.description"></el-option>
                                            </el-select>
                                            <small class="form-control-feedback" v-if="row.errors.payment_method_type_id" v-text="row.errors.payment_method_type_id[0]"></small>
                                        </div>
                                    </td>
                                    <td v-if="has_card">
                                        <div class="form-group mb-0" :class="{'has-danger': row.errors.card_brand_id}">
                                            <el-select v-model="row.card_brand_id" >
                                                <el-option v-for="option in card_brands" :key="option.id" :value="option.id" :label="option.description"></el-option>
                                            </el-select>
                                            <small class="form-control-feedback" v-if="row.errors.card_brand_id" v-text="row.errors.card_brand_id[0]"></small>
                                        </div>
                                    </td>
                                    <td v-else> 
                                    </td>
                                    <td>
                                        <div class="form-group mb-0" :class="{'has-danger': row.errors.reference}">
                                            <el-input v-model="row.reference"></el-input>
                                            <small class="form-control-feedback" v-if="row.errors.reference" v-text="row.errors.reference[0]"></small>
                                        </div>
                                    </td>
                                    
                                    <td>
                                        <div class="form-group mb-0" :class="{'has-danger': row.errors.payment}">
                                            <!-- <el-input v-model="row.payment"></el-input> -->
                                            <el-input  v-model="row.payment" >
                                                <template slot="prepend">S/ </template>
                                            </el-input>
                                            <small class="form-control-feedback" v-if="row.errors.payment" v-text="row.errors.payment[0]"></small>
                                        </div>
                                    </td>
                                    <td>
                                        -
                                    </td>
                                    <td class="series-table-actions text-right">
                                        <button type="button" class="btn waves-effect waves-light btn-xs btn-info" @click.prevent="clickSubmit(index)">
                                            <i class="fa fa-check"></i>
                                        </button>
                                        <button type="button" class="btn waves-effect waves-light btn-xs btn-danger" @click.prevent="clickCancel(index)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </td>
                                    <td>
                                        <el-upload
                                            class="upload-demo"
                                            :headers="headers"
                                            :action="`/${resource}/upload`"
                                            :data="{'index': index}"
                                            :multiple="false"
                                            :limit="1"
                                            :on-success="successUpload"
                                            :on-remove="(file, fileList) => removeFile(file, fileList, index)"
                                            :show-file-list="false"
                                        >
                                            <el-button
                                                slot="trigger" size="mini"
                                                type="primary"
                                            >
                                                Seleccionar archivo
                                            </el-button>
                                            <div slot="tip" class="el-upload__tip" v-if="row.file">
                                                Un archivo cargado
                                            </div>
                                        </el-upload>
                                    </td>
                                </template>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                                <td colspan="9" class="text-right">TOTAL PAGADO</td>
                                <td class="text-right">S/ {{ client.total_paid }}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colspan="9" class="text-right">TOTAL A PAGAR</td>
                                <td class="text-right">S/ {{ client.total }}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colspan="9" class="text-right">PENDIENTE DE PAGO</td>
                                <td class="text-right">S/ {{ client.total_pending }}</td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <div class="col-md-12 text-center pt-2" >
                    <el-button type="primary" icon="el-icon-plus" @click="clickAddRow">Programar pago</el-button>
                </div>
            </div>

        </div>
    </el-dialog>

</template>

<script>

    import {deletable} from '../../../../mixins/deletable'

    export default {
        props: ['showDialog', 'clientId'],
        mixins: [deletable],

        data() {
            return {
                title: null,
                recordId: null,
                resource: 'client_payments',
                records: [],
                payment_method_types: [],
                card_brands: [],
                showAddButton: true,
                has_card: false,
                client: {},
                headers: headers_token
            }
        },
        async created() {
            await this.initForm();
            await this.$http.get(`/${this.resource}/tables`)
                .then(response => {
                    this.payment_method_types = response.data.payment_method_types;
                    this.card_brands = response.data.card_brands;
                    //this.initDocumentTypes()
                })
        },
        methods: {
            changePaymentMethodType(row){
                let payment_method_type = _.find(this.payment_method_types,{'id':row.payment_method_type_id})
                this.has_card = (payment_method_type.has_card)? true:false
            },
            initForm() {
                this.records = [];
                this.showAddButton = true;
            },
            async getData() {
                this.initForm();
                await this.$http.get(`/${this.resource}/client/${this.clientId}`)
                    .then(response => {
                        this.client = response.data;
                        this.title = 'Programación de pagos del cliente: '+this.client.name;
                    })
                    .catch(error => {
                        if (error.response) {
                            let errors = error.response.data.message || 'Error al realizar la operación'
                            this.$message.error(errors)
                        }
                    })
                await this.$http.get(`/${this.resource}/records/${this.clientId}`)
                    .then(response => {
                        this.records = response.data.data
                    })
                    .catch(error => {
                        if (error.response) {
                            let errors = error.response.data.message || 'Error al realizar la operación'
                            this.$message.error(errors)
                        }
                    })
            },
            async clickCancelPayment(client_payment_id){
                await this.$http.get(`/${this.resource}/cancel_payment/${client_payment_id}`)
                    .then(response => { 
                        if (response.data.success) {
                            this.$message.success(response.data.message);
                            this.getData(); 
                        } else {
                            this.$message.error(response.data.message);
                        }
                    })
                    .catch(error => {
                        if (error.response) {
                            let errors = error.response.data.message || 'Error al realizar la operación'
                            this.$message.error(errors)
                        }
                    })
            },
            clickAddRow() {
                if (this.records.length) {
                    const record = this.records.filter(item => item.state === 'E')
                    if (record.length) {
                        this.$message.error('El cliente tiene un pago pendiente.')
                        return
                    }
                }

                this.records.push({
                    id: null,
                    date_of_due: moment().format('YYYY-MM-DD'),
                    date_of_payment: moment().format('YYYY-MM-DD'),
                    payment_method_type_id: null,
                    card_brand_id: null,
                    reference: null,
                    reference: null,
                    payment: this.client.pricing,
                    errors: {},
                    loading: false,
                    file: null,
                    temp_path: null
                });
                this.showAddButton = false;
            },
            clickCancel(index) {
                this.records.splice(index, 1);
                this.showAddButton = true;
            },
            clickSubmit(index) {
                if(this.has_card && this.records[index].card_brand_id == null) {
                    this.$message.error('Elija una tarjeta.');
                    return;
                }
                let form = {
                    id: this.records[index].id,
                    client_id: this.clientId,
                    date_of_due: this.records[index].date_of_due,
                    date_of_payment: this.records[index].date_of_payment,
                    payment_method_type_id: this.records[index].payment_method_type_id,
                    card_brand_id: this.records[index].card_brand_id,
                    reference: this.records[index].reference,
                    payment: this.records[index].payment,
                    file: this.records[index].file,
                    temp_path: this.records[index].temp_path
                };
                this.$http.post(`/${this.resource}`, form)
                    .then(response => {
                        if (response.data.success) {
                            this.$message.success(response.data.message);
                            this.getData();
                            // this.initDocumentTypes()
                            this.showAddButton = true;
                        } else {
                            this.$message.error(response.data.message);
                        }
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            this.records[index].errors = error.response.data;
                        } else {
                            console.log(error);
                            if (error.response) {
                                let message = error.response.data.message || 'Error al realizar la operación'
                                this.$message.error(message)
                            }
                        }
                    })
            }, 
            close() {
                this.$emit('update:showDialog', false);
                // this.initDocumentTypes()
                // this.initForm()
            },
            clickDelete(id) {
                this.destroy(`/${this.resource}/${id}`).then(() =>
                    this.getData()
                    // this.initDocumentTypes()
                )
            },

            getTypeState(state) {
                if (state === 'E') {
                    return 'warning'
                }
                if (state === 'P') {
                    return 'success'
                }
                if (state === 'V') {
                    return 'danger'
                }
                return 'info'
            },

            getNameState(state) {
                if (state === 'E') {
                    return 'Pendiente'
                }
                if (state === 'P') {
                    return 'Pagado'
                }
                if (state === 'V') {
                    return 'Vencido'
                }
                return 'Anulado'
            },

            successUpload(response) {
                if (response.success) {
                    this.records[response.data.index].file = response.data.filename
                    this.records[response.data.index].temp_path = response.data.temp_path
                } else {
                    this.$message.error(response.message)
                }
            },

            removeFile(file, fileList, index) {

            },

            async successUploadDirect(response) {
                if (response.success) {
                    this.$message.success(response.message)
                    await this.getData()
                } else {
                    this.$message.error(response.message)
                }
            },

            async donwloadFile(id) {
                window.open(`/${this.resource}/download/${id}`, '_blank')
            },

            deleteFile(id) {
                this.$confirm('¿Seguro de eliminar el archivo?', 'Advertencia', {
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'
                })
                .then(async () => {
                    try {
                        const { data } = await this.$http.post(`/${this.resource}/remove/${id}`)
                        if (data.success) {
                            this.$message.success(data.message)
                            await this.getData()
                        } else {
                            this.$message.error(data.message)
                        }
                    } catch (error) {
                        this.$message.error(error.response.data.message || 'Error al realizar la operación')
                    }
                })
                .catch(() => { })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/system/clients/partials/payments.vue